
export default {
  name: "MediasetBanner",
  data() {
    return {
      show: false
    }
  },
  mounted(){
    setTimeout(()=>{this.show = true}, 4000)
  }
}
